import React, { FC, useContext } from 'react'
import cx from 'classnames'

const Styles = require('./card.module.styl')

type Props = {
  cardCls?: string
}

export const Card: FC<Props> = props => {
  return <div className={cx(Styles['card'], props.cardCls)}>{props.children}</div>
}


